var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hiddenRow"},[_c('input',{staticClass:"form-control padding-l-bs",attrs:{"itemId":_vm.item && _vm.item.id,"type":"hidden"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/go-hidden.vue